import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FeatureAccessResetService, FeatureAccessResettable } from 'src/app/core/services/utelize/access/feature-access-reset-service';
import { Injectable } from '@angular/core';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

@Injectable({ providedIn: 'root' })

export class RiskIntelligenceAccessService implements FeatureAccessResettable {

  private featureEnabledRiskIntelligence: boolean=false;
  private featureLoaded                 : boolean=false;
  private inflightInit                  : Promise<void> | undefined;

  constructor(
    private authenticationService          : AuthenticationService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private exceptionsService              : ExceptionsService,
    private featureAccessResetService      : FeatureAccessResetService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService
  ) {
    this.featureAccessResetService.register(this);
  }

  public canShow(): boolean {
    try {
      const menuShown: boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowRiskManagement, false);

      if (!menuShown)
        return false;

      const hasAccessGuid: boolean=this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemRiskManagement, true);

      return hasAccessGuid || this.featureEnabledRiskIntelligence;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public async ensureInitialised(): Promise<void> {
    try {
      if (this.featureLoaded)
        return;

      if (this.inflightInit) {
        await this.inflightInit;
        return;
      }

      this.inflightInit=this.loadFeatureFlag();
      await this.inflightInit;
      this.inflightInit=undefined;
    }
    catch(e) {
      this.inflightInit=undefined;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isFeatureEnabled(): boolean {
    try {
      return this.featureEnabledRiskIntelligence;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public resetFeatureCache(): void {
    try {
      this.featureEnabledRiskIntelligence=false;
      this.featureLoaded                 =false;
      this.inflightInit                  =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async loadFeatureFlag(): Promise<void> {
    try {
      const curUser  : SystemUserDTO=this.authenticationService.currentUserObject();
      const companyId: number       =curUser?.companyId ?? -1;

      const data=await firstValueFrom(this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(companyId, AccessGuids.ChargeableFeatureRiskIntelligence)
                       .pipe(
                         catchError((error) => {
                           return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                         })
                       )
                      );

      this.featureEnabledRiskIntelligence=data.result;
      this.featureLoaded                 =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
